import {createAsyncThunk, createSlice} from "@reduxjs/toolkit"
import { TableData } from "../../types/table-filter-types"
import {getKrookies} from "../api";
import {formatTableTime} from "../../utils/format-table-dates";

interface InitialState {
    fullData: TableData,
    data: TableData,
    totalDataSize: number,
    selected: Array<number>,
    landuseDictionary: Array<{code: number, name: string}>;
    statusesDictionary: Array<{id: number, name: string}>;
    citiesDictionary: Array<{code: number, name: string}>;
    isLoading: boolean;
}

const initialState: InitialState = {
    fullData: [],
    data: [],
    totalDataSize: 0,
    selected: [], 
    landuseDictionary: [],
    statusesDictionary: [],
    citiesDictionary: [],
    isLoading: false,
}

export const fetchKrookies = createAsyncThunk(
    "table/fetchKrookies",
    async (_, { getState }) => {
        let res = await getKrookies();

        const { citiesDictionary, landuseDictionary } = (getState() as any).table;
        const { user } = (getState() as any).user;

        if (user && Array.isArray(user.cities) && user.cities.length > 0) {
            res = res.filter((item: any) => user.cities.includes(item.cityId));
        }

        res = res.map((item: any) => {
            let res2: Record<string, any> = {};

            for (const key in item) {
                if (
                    key != "cityId"
                ) {
                    res2[key] = item[key];
                }
            }

            if (citiesDictionary.length > 0) {
                res2.city = citiesDictionary.filter((obj: any) => obj.code == item.cityId)[0].name
                res2.cityAndAddress = `${res2.city}
                ${item.streetNum}`;
            }
            if (landuseDictionary.length > 0) {
                res2.landUse = landuseDictionary.filter((obj: any) => obj.code == item.landUse)[0].name;
            }

            res2.timeAndDrafter = `${formatTableTime(new Date(item.changedDateTime), "MM/DD/YYYY hh:mm pm")}
            ${item.userName}`;

            return { ...res2 };
        });

        res.sort((a: any, b: any) => b.id - a.id);

        return res
    }
);

export const tableSlice = createSlice({
    name: 'table',
    initialState: initialState,
    reducers: {
        setData: (state, {payload}) => {
            state.data = payload.data
            state.totalDataSize = payload.totalDataSize
        },
        addSelected: (state, {payload}) => {
            state.selected.push(...payload)
        },
        deleteSelected: (state, {payload}) => {
            let newSelected = state.selected
            payload.forEach((item1: any) => {
                newSelected = newSelected.filter(item2 => item1 != item2)
            })
            state.selected = newSelected
        },
        deleteAllSelected: (state) => {
            state.selected = []
        },
        setDictionaries: (state, {payload}) => {
            state.citiesDictionary = payload.cities
            state.landuseDictionary = payload.landuses
            state.statusesDictionary = payload.statuses
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchKrookies.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchKrookies.fulfilled, (state, action) => {
                state.fullData = action.payload;
                state.isLoading = false;
            })
            .addCase(fetchKrookies.rejected, (state) => {
                state.isLoading = false;
            });
    }
})

export const {setData, addSelected, deleteAllSelected, deleteSelected, setDictionaries} = tableSlice.actions